import { Box, FormLabel, InputLabel, MenuItem, Select } from '@mui/material';

import {
  FormData,
  IdeogramMagicPrompt,
  IdeogramResolution,
  IdeogramStyleType,
  IdeogramAspect,
} from './constants';

type Props = {
  formData: FormData;
  onChange: (e: any) => void;
};

const IdeogramAi = ({ formData, onChange }: Props) => {
  const ideogramModels = [
    {
      label: 'V3',
      value: 'ideogram-v3',
    },
    {
      label: 'V3-TURBO',
      value: 'ideogram-v3-turbo',
    },
    {
      label: 'V3-QUALITY',
      value: 'ideogram-v3-quality',
    },
  ];

  return (
    <>
      <Box>
        <Box>
          <FormLabel htmlFor='aiModel'>Ideogram models</FormLabel>
          <Select
            name='aiModel'
            className='nodrag'
            fullWidth
            value={formData.aiModel}
            onChange={onChange}
          >
            <MenuItem disabled value='noValue'>
              {'Choose an Engine'}
            </MenuItem>
            {ideogramModels?.map((model, index) => {
              return (
                <MenuItem key={index} value={model.value}>
                  {model.label}
                </MenuItem>
              );
            })}
          </Select>
        </Box>

        <Box>
          <InputLabel htmlFor='type'>Aspect Ratio </InputLabel>

          <Select
            name='aspect_ratio_ideogram'
            className='nodrag'
            value={formData.aspect_ratio_ideogram || ''}
            onChange={onChange}
            fullWidth
          >
            <MenuItem value={''}></MenuItem>
            {Object.values(IdeogramAspect)?.map((item, index) => (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box>
          <InputLabel htmlFor='type'>Style Type</InputLabel>

          <Select
            name='style_type'
            className='nodrag'
            value={formData.style_type || ''}
            onChange={onChange}
            fullWidth
          >
            <MenuItem value={''}></MenuItem>
            {Object.values(IdeogramStyleType)?.map((item, index) => (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box>
          <InputLabel htmlFor='type'>Resolution</InputLabel>

          <Select
            name='resolution'
            className='nodrag'
            value={formData.resolution || ''}
            onChange={onChange}
            fullWidth
          >
            <MenuItem value={''}></MenuItem>
            {Object.values(IdeogramResolution)?.map((item, index) => (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box>
          <InputLabel htmlFor='type'>Magic Prompt</InputLabel>

          <Select
            name='magicPrompt'
            className='nodrag'
            value={formData.magicPrompt || ''}
            onChange={onChange}
            fullWidth
          >
            <MenuItem value={''}></MenuItem>
            {Object.values(IdeogramMagicPrompt)?.map((item, index) => (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
    </>
  );
};

export default IdeogramAi;
